import React from 'react';
import Layout from '../../components/Shared/Layout';
import OmniFitness from '../../components/Portfolio/omni-active';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class OmniFitnessPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/omni-fitness',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <OmniFitness />
      </Layout>
    );
  }
}

export default OmniFitnessPage;
